import { alpha, createTheme } from '@mui/material/styles';

/** Blu brand (allineato a UX Industrial Integrity) */
const CANTIR_BLUE = '#1B4FD8';

export const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#1565C0',
      light: '#1E88E5',
      dark: '#0D47A1',
    },
    secondary: {
      main: '#FF6F00',
    },
    background: {
      default: '#F8FAFC',
      paper: '#FFFFFF',
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: { fontSize: '36px', lineHeight: 1.2, fontWeight: 700, letterSpacing: '-0.02em' },
    h2: { fontSize: '24px', lineHeight: 1.3, fontWeight: 600, letterSpacing: '-0.01em' },
    h3: { fontSize: '18px', lineHeight: 1.4, fontWeight: 600 },
    h4: { fontSize: '24px', lineHeight: 1.3, fontWeight: 600, letterSpacing: '-0.01em' },
    h5: { fontSize: '24px', lineHeight: 1.3, fontWeight: 700, letterSpacing: '-0.01em' },
    h6: { fontSize: '18px', lineHeight: 1.4, fontWeight: 600 },
    subtitle1: { fontSize: '16px', lineHeight: 1.5, fontWeight: 600 },
    subtitle2: { fontSize: '14px', lineHeight: 1.4, fontWeight: 600 },
    body1: { fontSize: '16px', lineHeight: 1.5, fontWeight: 400 },
    body2: { fontSize: '14px', lineHeight: 1.5, fontWeight: 400 },
    button: { fontSize: '14px', lineHeight: 1.2, fontWeight: 600, textTransform: 'none' },
    caption: { fontSize: '12px', lineHeight: 1, fontWeight: 700, letterSpacing: '0.05em' },
    overline: { fontSize: '12px', lineHeight: 1, fontWeight: 700, letterSpacing: '0.05em', textTransform: 'uppercase' },
  },
  shape: {
    borderRadius: 4,
  },
  components: {
    MuiContainer: {
      defaultProps: {
        disableGutters: true,
        maxWidth: false,
      },
      styleOverrides: {
        root: ({ theme: t }) => ({
          paddingLeft: t.spacing(1.5),
          paddingRight: t.spacing(1.5),
          [t.breakpoints.up('sm')]: {
            paddingLeft: t.spacing(3),
            paddingRight: t.spacing(3),
          },
          [t.breakpoints.up('md')]: {
            paddingLeft: t.spacing(4),
            paddingRight: t.spacing(4),
          },
        }),
        maxWidthXs: { maxWidth: 'none' },
        maxWidthSm: { maxWidth: 'none' },
        maxWidthMd: { maxWidth: 'none' },
        maxWidthLg: { maxWidth: 'none' },
        maxWidthXl: { maxWidth: 'none' },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: { textTransform: 'none', fontWeight: 600, fontSize: '14px' },
        sizeSmall: { fontSize: '12px' },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          fontSize: '16px',
        },
        inputSizeSmall: {
          fontSize: '14px',
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontSize: '16px',
        },
        sizeSmall: {
          fontSize: '14px',
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          fontSize: '12px',
          lineHeight: 1.4,
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        message: {
          fontSize: '14px',
          lineHeight: 1.45,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        label: {
          fontSize: '11px',
          lineHeight: 1.2,
          fontWeight: 700,
        },
        labelSmall: {
          fontSize: '10px',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          fontSize: '14px',
          lineHeight: 1.5,
        },
        head: {
          fontSize: '12px',
          fontWeight: 700,
          letterSpacing: '0.05em',
          textTransform: 'uppercase',
          lineHeight: 1,
        },
      },
    },
    MuiButtonBase: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            color: CANTIR_BLUE,
            backgroundColor: alpha(CANTIR_BLUE, 0.12),
            '&:hover': {
              backgroundColor: alpha(CANTIR_BLUE, 0.2),
            },
          },
        },
      },
    },
    MuiToggleButton: {
      styleOverrides: {
        root: {
          fontSize: '14px',
          '&.Mui-selected': {
            color: CANTIR_BLUE,
            backgroundColor: alpha(CANTIR_BLUE, 0.12),
            borderColor: alpha(CANTIR_BLUE, 0.5),
            '&:hover': {
              backgroundColor: alpha(CANTIR_BLUE, 0.2),
            },
          },
        },
      },
    },
    MuiTextField: {
      defaultProps: { variant: 'outlined', fullWidth: true },
    },
  },
});
